import React from "react";
import { useState, useEffect, useMemo, useRef } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { Box, Button } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import useLoader from "../Hooks/useLoader";
import SnackBar from "../component/SnackBar";
import { CustomTableFunction } from "../Table/Table";

const DetailedTable = (props) => {
  const [data, setData] = useState(props.data);
  const [showTable, setShowTable] = useState(false);
  const [validationErrors] = useState({});
  const [loader, showLoader, hideLoader] = useLoader({
    heightOfLoader: "132vh",
    marginTopLoader: "60%",
  });
  const navigate = useNavigate();
  const alertRef = useRef();
  const [colFilter, setColFilter] = useState([]);

  useEffect(() => {
    try {
      setShowTable(props.tableValue);
    } catch (error) {}
  }, [props.tableValue]);
  useEffect(() => {
    try {
      setData(props.data);
    } catch (error) {}
  }, [props.data]);
  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
  });
  const handleExportData = async () => {
  try {
    showLoader();

    const cleanedData = props.data.map((row) => {
      const newRow = {};
      Object.keys(row).forEach((key) => {
        const newKey = key
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        newRow[newKey] = row[key];
      });
      return newRow;
    });

    const csv = generateCsv(csvConfig)(cleanedData);
    download(csvConfig)(csv);

    hideLoader();
  } catch (error) {
    hideLoader();
  }
};
  const handleExportRows = (rows) => {
  const rowData = rows.map((row) => {
    const original = row.original;
    const cleanedRow = {};

    Object.keys(original).forEach((key) => {
      const newKey = key
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      cleanedRow[newKey] = original[key];
    });

    return cleanedRow;
  });

  const csv = generateCsv(csvConfig)(rowData);
  download(csvConfig)(csv);
};

  let columns = useMemo(
    () => [
      {
        accessorKey: "Contract_Id",
        header: "Contract ID",
        minSize: 60,
        maxSize: 60,
        size: 60,
        muiTableHeadCellProps: { sx: { color: "#002677" } }, //custom props
        enableEditing: false,
        muiFilterTextFieldProps: { placeholder: "Contract ID" },
      },
       {
        accessorKey: "Optum_company_name",
        header: "Optum Company Name",
        minSize: 60,
        maxSize: 60,
        size: 60,
        muiTableHeadCellProps: { sx: { color: "#002677" } }, //custom props
        enableEditing: false,
        muiFilterTextFieldProps: { placeholder: "Optum Company Name" },
      },
       {
        accessorKey: "Line_of_business",
        header: "Line Of Business",
        minSize: 60,
        maxSize: 60,
        size: 60,
        muiTableHeadCellProps: { sx: { color: "#002677" } }, //custom props
        enableEditing: false,
        muiFilterTextFieldProps: { placeholder: "Line Of Business" },
      },
      
      {
        accessorKey: "Contract_Name",
        header: "Contract Name",
        minSize: 60,
        maxSize: 60,
        size: 60,
        muiTableHeadCellProps: { sx: { color: "#002677" } }, //custom props
        enableEditing: false,
        muiFilterTextFieldProps: { placeholder: "Contract Name" },
      },
      {
        accessorKey: "Client_Name",
        header: "Client Name",
        minSize: 60,
        maxSize: 60,
        size: 60,
        muiTableHeadCellProps: { sx: { color: "#002677" } }, //custom props
        enableEditing: false,
        muiFilterTextFieldProps: { placeholder: "Client Name" },
      },
      {
        accessorKey: "Contract_Start_Date",
        header: "Effective Date",

        filterVariant: "date-range",
        filterFn: (row, columnId, filterValue) => {
          const rowValue = new Date(row.getValue(columnId));
          const [start, end] = filterValue;
          const startDate = start ? new Date(start) : null;
          const endDate = end ? new Date(end) : null;
          if (!start && !end) return true;
          if (startDate) startDate.setHours(0, 0, 0, 0);
          if (endDate) endDate.setHours(23, 59, 59, 999);
          if (startDate && !endDate) return rowValue >= startDate;
          if (!startDate && endDate) return rowValue <= endDate;
          if (startDate && endDate)
            return rowValue >= startDate && rowValue <= endDate;
        },
        size: 30,
        muiTableHeadCellProps: { sx: { color: "#002677" } }, //custom props
        // Cell: ({ cell }) => cell.getValue().toLocaleDateString(),
        sortDescFirst: false,
        enableEditing: false,
        muiFilterTextFieldProps: { placeholder: "Effective Date" },
      },
      {
        accessorKey: "Status",
        header: "Status",
        minSize: 60,
        maxSize: 60,
        size: 60,
        muiTableHeadCellProps: { sx: { color: "#002677" } }, //custom props
        enableEditing: false,
        muiFilterTextFieldProps: { placeholder: "Status" },
      },
      {
        accessorKey: "Failure_Status",
        header: "Failure Reason",
        minSize: 60,
        maxSize: 60,
        size: 60,
        muiTableHeadCellProps: { sx: { color: "#002677" } }, //custom props
        enableEditing: false,
        muiFilterTextFieldProps: { placeholder: "Failure Reason" },
      },
     
    ],
    [validationErrors]
  );

  const tableProperties = {
    enableGrouping: false,
    // initialState: { showColumnFilters: true },
    groupedColumnMode: "remove",
    enableSorting: true,
    editDisplayMode: "table",
    // muiTableContainerProps: { sx: { } },
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    muiTableHeadRowProps: { sx: { backgroundColor: "transparent" } },
    muiTopToolbarProps: { sx: { backgroundColor: "transparent" } },
    muiTableFooterRowProps: { sx: { backgroundColor: "transparent" } },
    muiBottomToolbarProps: { sx: { backgroundColor: "transparent" } },
    muiTablePaperProps: {
      sx: {
        boxShadow: "none",
        border: "none",
        backgroundColor: "transparent",
      },
    },
    muiTableProps: {
      sx: {
        borderCollapse: "collapse",
      },
    },
    // columnFilterDisplayMode: 'popover',
    muiTableBodyRowProps: {
      sx: (theme) => ({
        borderSpacing: "0 10px",
        borderBottom: "5px solid transparent",
      }),
    },
    muiPaginationProps: {
      color: "primary",
      shape: "circular",
      showRowsPerPage: false,
      variant: "outlined",
    },
    paginationDisplayMode: "pages",
    renderTopToolbarCustomActions: ({ table }) => {
      return (
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            // padding: '8px',
            flexWrap: "wrap",
          }}
        >
          <Button
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={handleExportData}
            startIcon={<FileDownloadIcon />}
          >
            Export All Data
          </Button>
          <Button
            // disabled={colFilter===false||table.getPrePaginationRowModel().rows.length===0}
            //export all rows, including from the next page, (still respects filtering and sorting)
            onClick={() =>
              handleExportRows(table.getPrePaginationRowModel().rows)
            }
            startIcon={<FileDownloadIcon />}
          >
            Export Filtered Data
          </Button>
        </Box>
      );
    },
  };

  const table = CustomTableFunction({
    columns: columns,
    data: data, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    tableProperties: tableProperties,
  });

  return (
    <div>
      {loader}
      {showTable && <MaterialReactTable table={table} />}
      <SnackBar ref={alertRef} />
    </div>
  );
};

export default DetailedTable;
